/**
 * IDs required before creating campaigns or sending influencer invites.
 * Keep in sync with server `CAMPAIGN_AND_INVITE_ACTIVATION_TASK_IDS` (brandActivation.service.js).
 */
export const BRAND_ACTIVATION_REFRESH_EVENT = 'millet:brand-activation-refresh';

/** Call after brand profile or assets change so checklist / gates can refetch `/api/brand/activation`. */
export function requestBrandActivationRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BRAND_ACTIVATION_REFRESH_EVENT));
  }
}

export const BRAND_CAMPAIGN_INVITE_REQUIRED_TASK_IDS = Object.freeze([
  'brand_logo',
  'brand_description',
  'brand_link',
]);

export function areBrandCampaignInviteTasksComplete(activation) {
  if (!activation?.tasks?.length) return false;
  const map = new Map(activation.tasks.map((t) => [t.id, t]));
  return BRAND_CAMPAIGN_INVITE_REQUIRED_TASK_IDS.every((id) => map.get(id)?.done);
}

export function getIncompleteBrandCampaignInviteTasks(activation) {
  const map = new Map((activation?.tasks || []).map((t) => [t.id, t]));
  return BRAND_CAMPAIGN_INVITE_REQUIRED_TASK_IDS.map((id) => map.get(id)).filter(
    (task) => task && !task.done,
  );
}

function sortTasksIncompleteFirst(tasks = []) {
  return [...tasks].sort((a, b) => {
    if (a.done === b.done) return 0;
    return a.done ? 1 : -1;
  });
}

export function partitionBrandActivationTasks(activation) {
  const tasks = Array.isArray(activation?.tasks) ? activation.tasks : [];
  return {
    required: sortTasksIncompleteFirst(tasks.filter((task) => !task.optional)),
    optional: sortTasksIncompleteFirst(tasks.filter((task) => task.optional)),
  };
}

export function getIncompleteBrandRequiredTasks(activation) {
  return partitionBrandActivationTasks(activation).required.filter((task) => !task.done);
}

export function isBrandChecklistComplete(activation) {
  if (!activation || activation.dismissed) return true;
  const { required, optional } = partitionBrandActivationTasks(activation);
  if (required.length === 0 && optional.length === 0) return true;
  return required.every((task) => task.done) && optional.every((task) => task.done);
}
